import { render } from "./SplitSegment.vue?vue&type=template&id=b72d368a&scoped=true&ts=true"
import script from "./SplitSegment.vue?vue&type=script&lang=ts"
export * from "./SplitSegment.vue?vue&type=script&lang=ts"

import "./SplitSegment.vue?vue&type=style&index=0&id=b72d368a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72d368a"]])

export default __exports__